import { CircularProgress } from "@mui/joy"
import { Box } from "@mui/material"
import React from "react"

export function Loader() {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <CircularProgress
        color="primary"
        determinate={false}
        size="lg"
        value={20}
        variant="plain"
      />
    </Box>
  )
}
